import * as React from 'react';
import { ResultItem } from '../../types';
import AdMarking from '../general/ad-marking';
import Logo from '../general/logo';
import Srcset from '../general/srcset';

export type Props = { resultItem: ResultItem };

export default function CarResults(props: Props) {
    const { resultItem } = props;
    const { heading, svgLogo, orgName, srcSet, mainImage } = resultItem;

    return (
        <div
            className="car-banner"
            data-controller="srcsetController imgSrcController"
        >
            <div className="media-wrapper">
                <AdMarking />
                <div className="car_overlay">
                    <Logo svgLogo={svgLogo} orgName={orgName} />
                </div>
                <div
                    className="media"
                    style={{ backgroundImage: `url('${mainImage}')` }}
                >
                    <Srcset srcSet={srcSet} mainImage={mainImage} />
                </div>
            </div>
            <div className="caption-wrapper">
                <div className="caption-heading line-clamp-heading line-clamp-2">
                    {heading}
                </div>
            </div>
        </div>
    );
}
